export const BU = {
  Indigo: 'Indigo',
  LF: 'LF',
  Scitex: 'Scitex',
  PWI: 'PWI',
};

export const PILLAR = {
  Optimize: 'Optimize',
  Automate: 'Automate',
  Grow: 'Grow',
};
// id: landing page identifier for application - drives Name and Description
// appId: application id associated with this item - drives Icon
// name: display name for application
// desc: description for the application
// icon: cdn reference to icon associated with the application
// bgImage: cdn reference to image to associate with the application
// pillar: Which pillar is the application associated with?
// businessUnits: Which business units is this application associated with?
export const appDefinitions = [
  {
    id: 'print-beat',
    appId: 'printbeat',
    bgImage: 'url("https://picsum.photos/1920/1080?random&1")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&1")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo, BU.LF, BU.PWI, BU.Scitex],
    content: [
      {
        type: 'video',
        videoIds: {
          en: '86BHQ1vGzyM',
        }
      },
    ],
  },
  {
    id: 'media-locator',
    appId: 'ml',
    bgImage: 'url("https://picsum.photos/1920/1080?random&2")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&2")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI],
  },
  {
    id: 'knowledge-zone',
    appId: 'information-center',
    bgImage: 'url("https://picsum.photos/1920/1080?random&3")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&3")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo, BU.PWI, BU.Scitex],
  },
  {
    id: 'print-beat-mobile',
    appId: 'print-beat-mobile',
    bgImage: 'url("https://picsum.photos/1920/1080?random&4")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&4")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo],
  },
  {
    id: 'service-center',
    appId: 'pwi-sc',
    bgImage: 'url("https://picsum.photos/1920/1080?random&5")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&5")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI],
  },
  {
    id: 'service-center-channels',
    appId: 'reseller-portal',
    bgImage: 'url("https://picsum.photos/1920/1080?random&6")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&6")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.LF],
  },
  {
    id: 'substrate-manager',
    appId: 'csm',
    bgImage: 'url("https://picsum.photos/1920/1080?random&7")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&7")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo],
  },
  {
    id: 'configuration-center',
    appId: 'color-config',
    bgImage: 'url("https://picsum.photos/1920/1080?random&8")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&8")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.LF],
  },
  {
    id: 'jobs-api',
    appId: 'jobs',
    bgImage: 'url("https://picsum.photos/1920/1080?random&9")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&9")',
    pillar: PILLAR.Optimize,
    businessUnits: [BU.Indigo],
  },
  {
    id: 'site-flow',
    appId: 'production',
    bgImage: 'url("https://picsum.photos/1920/1080?random&10")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&10")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo, BU.Scitex, BU.PWI],
  },
  {
    id: 'box',
    appId: 'box',
    bgImage: 'url("https://picsum.photos/1920/1080?random&11")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&11")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI],
  },
  {
    id: 'composer',
    appId: 'composer',
    bgImage: 'url("https://picsum.photos/1920/1080?random&12")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&12")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo, BU.Scitex, BU.PWI],
    content: [
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/composer/company-wihabo.jpg',
          quote: 'PrintOS Composer has been greatly effective in delivering our award winning <a class=\"link\" href=\"https://www.wihabo.nl/vers-van-de-pers/tony-s-limited-editions-are-really-one-of-a-kind\" target=\"_blank\">Tony\'s Chocolonely</a> VDP project quickly and accurately.',
          picture: 'https://cdn.printos.com/images/market/products/summary/composer/wihabo-testimonial1.jpg',
          name: 'Mike Rovers',
          title: 'Studio Manager',
          company: '<a class=\"company-link\" href=\"https://www.wihabo.nl/\" target=\"_blank\">Wihabo</a>',
        }
      },
      {
        type: 'testimonial',
        options: {
          layout: 'personal-1',
          logo: 'https://cdn.printos.com/images/market/products/summary/composer/company-feburman.png',
          quote: 'Creating the <a class=\"link\" href=\"http://www.hellorichard.co.uk/?portfolio=fes-watch-u-x-g-f-smith" target=\"_blank\">Sony FES Watch U</a> campaign, required a robust Variable PDF creation tool.  PrintOS Composer provided us with exactly what we needed.',
          picture: 'https://cdn.printos.com/images/market/products/summary/composer/feburman-testimonial1.jpg',
          name: 'Roger White',
          title: 'Creative & Technical Lead',
          company: '<a class=\"company-link\" href=\"https://www.feburman.co.uk/\" target=\"_blank\">F.E. Burman</a>',
        }
      },
      {
        type: 'video',
        videoIds: {
          en: 'WUvQ3KIqDd4',
        }
      },
    ],
    // learn: {
    //   link: 'https://hp.com',
    // }
  },
  {
    id: 'imposer',
    appId: 'imposer',
    bgImage: 'url("https://picsum.photos/1920/1080?random&13")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&13")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo, BU.LF, BU.Scitex, BU.PWI],
  },
  {
    id: 'resource-manager',
    appId: 'resourcemanager',
    bgImage: 'url("https://picsum.photos/1920/1080?random&14")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&14")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.Indigo],
  },
  {
    id: 'applications-center',
    appId: 'wallart',
    bgImage: 'url("https://picsum.photos/1920/1080?random&15")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&15")',
    pillar: PILLAR.Automate,
    businessUnits: [BU.LF],
  },
  {
    id: 'marketplace-licenses',
    appId: 'marketplace',
    bgImage: 'url("https://picsum.photos/1920/1080?random&16")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&16")',
    pillar: PILLAR.Grow,
    businessUnits: [BU.Indigo],
  },
  {
    id: 'marketplace-ideas',
    appId: 'marketplace',
    bgImage: 'url("https://picsum.photos/id/631/1920/1080")',
    // bgImage: 'url("https://picsum.photos/g/1920/1080?random&17")',
    pillar: PILLAR.Grow,
    businessUnits: [BU.Indigo],
  },
];



// WEBPACK FOOTER //
// ./components/landing-content/app-definitions.js